var DIC = {
  WEEK: [
    {
      label: '周一',
      value: '1',
    },
    {
      label: '周二',
      value: '2',
    },
    {
      label: '周三',
      value: '3',
    },
    {
      label: '周四',
      value: '4',
    },
    {
      label: '周五',
      value: '5',
    },
    {
      label: '周六',
      value: '6',
    },
    {
      label: '周天',
      value: '7',
    },
  ],
  MONTH: [
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
    {
      label: '4',
      value: '4',
    },
    {
      label: '5',
      value: '5',
    },
    {
      label: '6',
      value: '6',
    },
    {
      label: '7',
      value: '7',
    },
    {
      label: '8',
      value: '8',
    },
    {
      label: '9',
      value: '9',
    },
    {
      label: '10',
      value: '10',
    },
    {
      label: '11',
      value: '11',
    },
    {
      label: '12',
      value: '12',
    },
    {
      label: '13',
      value: '13',
    },
    {
      label: '14',
      value: '14',
    },
    {
      label: '15',
      value: '15',
    },
    {
      label: '16',
      value: '16',
    },
    {
      label: '17',
      value: '17',
    },
    {
      label: '18',
      value: '18',
    },
    {
      label: '19',
      value: '19',
    },
    {
      label: '20',
      value: '20',
    },
    {
      label: '21',
      value: '21',
    },
    {
      label: '22',
      value: '22',
    },
    {
      label: '23',
      value: '23',
    },
    {
      label: '24',
      value: '24',
    },
    {
      label: '25',
      value: '25',
    },
    {
      label: '26',
      value: '26',
    },
    {
      label: '27',
      value: '27',
    },
    {
      label: '28',
      value: '28',
    },
    {
      label: '29',
      value: '29',
    },
    {
      label: '30',
      value: '30',
    },
    {
      label: '31',
      value: '31',
    },
  ],
};
var V = (rule, value, callback) => {
  if (value > 60) {
    callback(new Error('逾期时间范围请控制在1-60'));
  } else if (value < 1) {
    callback(new Error('逾期时间范围请控制在1-60'));
  } else {
    callback();
  }
};
export default {
  submitText: '提交',
  emptyBtn: false,
  labelWidth: 120,
  column: [],
  group: [
    {
      dialogDirection: 'rtl',
      dialogType: 'drawer',
      label: '计划信息',
      arrow: false,
      column: [
        {
          label: '计划名称',
          prop: 'planName',
          maxlength: 30,
          showWordLimit: true,
          rules: [
            {
              required: true,
              message: '请输入计划名称',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '计划日期',
          prop: 'planTimeRange',
          searchRange: true,
          type: 'daterange',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() <= Date.now();
            },
          },
          rules: [
            {
              required: true,
              message: '请选择计划日期',
              trigger: 'blur',
            },
          ],
        },
      ],
    },
    {
      dialogDirection: 'rtl',
      label: '周期信息',
      arrow: false,
      column: [
        {
          label: '巡检周期',
          prop: 'inspectCycleType',
          type: 'radio',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=inspect_cycle_type',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [
            {
              required: true,
              message: '请输入巡检周期',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '具体时间',
          prop: 'detailTimeWeek',
          type: 'checkbox',
          dicData: DIC.WEEK,
          span: 24,
          display: false,
          rules: [
            {
              required: true,
              message: '请选择具体时间',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '具体时间',
          prop: 'detailTimeMonth',
          type: 'checkbox',
          all: true,
          dicData: DIC.MONTH,
          span: 24,
          display: false,
          rules: [
            {
              required: true,
              message: '请选择具体时间',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '巡视开始时间',
          prop: 'inspectBeginTime',
          type: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          display: false,
          rules: [
            {
              required: true,
              message: '请输入巡视开始时间',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '巡检天数',
          prop: 'num',
          type: 'number',
          display: false,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
            {
              required: true,
              message: '请输入巡检天数',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '周期休息天数（天）',
          prop: 'intervalTime',
          type: 'number',
          display: false,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数' },
            {
              required: true,
              message: '请输入周期休息天数（天）',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '允许逾期',
          prop: 'staleDatedStatus',
          type: 'radio',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=stale_dated_status',
          tip:
            '是否允许巡检任务完成时间逾期。示例：某巡检任务设定2点-6点必须完成。选中是：允许逾期。设定逾期时间：30分钟，可以允许最晚6点30巡检完成。',
          tipPlacement: 'top-start',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [
            {
              required: true,
              message: '请选择是否允许超期',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '逾期时间(分钟)',
          prop: 'beyondTheTime',
          display: false,
          rules: [
            { pattern: /^[0-9]*[0-9][0-9]*$/, message: '请输入正整数', trigger: 'blur' },
            {
              required: true,
              message: '请输入逾期时间(分钟)',
              trigger: 'blur',
            },
            {
              validator: V,
              message: '逾期时间范围请控制在1-60分钟',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '时间段',
          span: 24,
          row: true,
          prop: 'time',
          formslot: true,
          typeslot: true,
          labelslot: true,

          rules: [
            {
              required: false,
              message: '开始时间不能为空',
              trigger: 'blur',
            },
          ],
        },
      ],
    },
    {
      dialogDirection: 'rtl',
      label: '巡检信息',
      arrow: false,
      column: [
        {
          label: '所属小区',
          prop: 'areaId',
          formslot: true,
          labelslot: true,
          errorslot: true,
        },
        {
          label: '班组名称',
          prop: 'groupId',
          formslot: true,
          labelslot: true,
          errorslot: true,
          rules: [
            {
              required: true,
              message: '选择班组名称',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '巡检点名称',
          prop: 'nodeId',
          formslot: true,
          labelslot: true,
          errorslot: true,
          rules: [
            {
              required: true,
              message: '请选择巡检点名称',
              trigger: 'blur',
            },
          ],
        },
        // {
        //   label: '所属小区',
        //   prop: 'areaId',
        //   type: 'tree',
        //   dataType: 'string',
        //   dicUrl: 'api/base/property/treeChildrenPowerNode',
        //   props: { label: 'objectFullName', value: 'id' },
        //   cascaderItem: ['groupId', 'nodeId'],
        // },
        // {
        //   label: '班组名称',
        //   prop: 'groupId',
        //   type: 'tree',
        //   dicUrl: 'api/inspectGroup/inspectGroupTree?id={{key}}',
        //   props: { label: 'groupName', value: 'id' },
        //   rules: [
        //     {
        //       required: true,
        //       message: '选择班组名称',
        //       trigger: 'blur',
        //     },
        //   ],
        // },
        // {
        //   label: '巡检点名称',
        //   prop: 'nodeId',
        //   type: 'tree',
        //   dataType: 'string',
        //   multiple: true,
        //   dicUrl: 'api/inspectNode/inspectNodeTree?id={{key}}',
        //   props: { label: 'nodeName', value: 'id' },
        //   rules: [
        //     {
        //       required: true,
        //       message: '请选择巡检点名称',
        //       trigger: 'blur',
        //     },
        //   ],
        // },
        {
          prop: 'crud1',
          label: '巡检项',
          formslot: true,
          labelslot: true,
          span: 24,
        },
      ],
    },
  ],
};
